import { userNameInvalidMessageMap } from './errorDictionary';
import { isValidUsername } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useValidUsername() {
    const errorMessageMap = [userNameInvalidMessageMap];
    const validators = [isValidUsername];
    return useValidators(errorMessageMap, validators);
}
export default useValidUsername;
